import { WallCategory } from "./types/wallTypes";

export const WALL_CATEGORIES: WallCategory[] = Object.values(WallCategory);

/** Fixed reaction set offered in the UI (stored as a free string on the API). */
export const REACTION_TYPES = ["👍", "❤️", "🎉"];
